import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CallAPI } from "../../utils/apiActions";
import { showToast } from "../../helper/toastHelper";
import { LABEL } from "../../utils/constant";
import { GO_HIGH_LEVEL } from "../../utils/APIEndPoints";

const ConnectGoHighLevelCode = () => {
  const query = new URLSearchParams(useLocation().search);
  const tick = useRef(false);
  const initialCode = query.get("code") || "";
  const [code, setCode] = useState(initialCode);
  const navigate = useNavigate();
  const saveCode = async (e) => {
    if (tick.current) return;
    tick.current = true;
    const data = { code };
    if (!data) return;
    console.log("try-try");
    try {
      const response = await CallAPI(
        "USER",
        "POST",
        GO_HIGH_LEVEL.CALLBACK,
        data,
      );

      if (response?.res?.data?.msg) {
        showToast(response.res.data.msg, LABEL.TOAST_TYPE.SUCCESS);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setCode("");
      navigate(window.location.pathname);
    }
  };
  useEffect(() => {
    code && saveCode();
  }, [code]);

  if (!code) return null;
  //
  return (
    <div className="user-details-form modal-form-grid pt-3 form-step-2">
      <div className="wait-moment-message">
        <h2>One Moment Please</h2>
        <h6>
          We are connecting with your account please dont go back or press any
          button.
        </h6>
        <img src="/images/loader-bouncing-circles.svg" alt="" />
      </div>
    </div>
  );
};

export default ConnectGoHighLevelCode;
